/**
 * №22.6 (H2/O1) — the "answered today" window bound.
 *
 * Its own file only because `AnsweredStrip.tsx` must export components alone for
 * fast refresh to work; the rule is the repo's, the reason is the bundler's.
 */

/** Local midnight today, as ISO — the lower bound for "Answered today". LOCAL,
 *  not UTC: the supervisor's "today" is the one on their wall, and an AEST
 *  evening is already tomorrow in UTC, which would empty the strip at 10am. */
export function todayStartISO(): string {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d.toISOString();
}
